import { AuthService } from '@core/services';

export function appInitializer(authService: AuthService) {
  return () => authService.refreshToken();
}
